import React, { useState } from 'react';
import {signUp} from "@aws-amplify/auth"
import { Center, Stack, Input, Button } from '@mantine/core';
import { IconAt } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
// import {use} from 
const SignUp: React.FC = () => {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const navigate = useNavigate();

  const handleSignUp = async () => {
    try {
      await signUp({
        username,
        password,
        options: {
          userAttributes: {
            username,
          }
        }
      });
      setMessage("Sign-up successful. Please check your email for the confirmation code.");
      navigate('/confirm-signup');
    } catch (error) {
      console.error('Error during sign-up:', error);
      setMessage("Failed to sign up");
    }
  };

  return (
    <Center>
      <Stack>
      <h1 style={{margin: 'auto'}}>Sign Up</h1>
      <Input
        type="text"
        placeholder="Email"
        leftSection={<IconAt size={16}/>}
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <Input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button onClick={handleSignUp}>Sign Up</Button>
      <p>{message}</p>
      </Stack>
    </Center>
  );
}

export default SignUp;